import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request, refreshToken } from "@/js/http/http_request";
import { isMobile, isBreakPointMenuMobile } from "@/js/mobile/mobile.js";
import menuComponent from "@/components/menu/Menu.vue";
import cart from "@/components/cart/Cart.vue";
import { disconnect, hasRole, getIdUserFromSession, getIdUserFromToken, setIdUserInSession, getLoggedUserData, isUserBuyerGroup } from "@/js/http/auth.js";
import { getMenuItems } from "@/js/user/user_menu.js";
import * as orderHandler from "@/js/order/order.js";
import { orderStatus } from "@/js/lists.ts";
import Loading from "vue-loading-overlay";
import { orderPaths } from "@/router.js";
import footerComponent from "@/components/footer/Footer.vue";
import ScheduledMaintenanceAlert from "@/components/maintenance/ScheduledMaintenanceAlert.vue";
var mql = window.matchMedia("(max-width: 500px)");
export default {
  name: "userProfile",
  data: function data() {
    return {
      loggedUserData: {},
      modalWarningShown: false,
      modalWarning: {},
      cartDisabled: false,
      isCountdownElapsed: false,
      areAllItemsAddedToCart: false,
      timelapseInterval: null,
      lockerTimelapseIntervale: null,
      timelapse: null,
      svgCart: require("@/assets/images/icons/cart.svg"),
      hoverCart: false,
      loading: {
        isLoading: false,
        color: "#353535",
        bgColor: "#000000",
        opacity: 0.1,
        fullPage: true,
        canCancel: false,
        loader: "spinner"
      },
      buyer: true,
      menus: [],
      cart: false,
      orderStatus: orderStatus,
      nbItems: 0,
      portraitMobile: false
    };
  },
  computed: {
    isMaintenanceMode: function isMaintenanceMode() {
      return !this.$maintenanceMode.isActive || hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS);
    }
  },
  watch: {
    $route: function $route() {
      this.cartDisabled = this.isCompletingOrder();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var order, _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.loggedUserData = getLoggedUserData();
            _context.next = 3;
            return getMenuItems();
          case 3:
            _this2.menus = _context.sent;
            window.addEventListener("storage", function (e) {
              if (e.key === "current_order") {
                if (!!e.newValue) {
                  _this2.eventUpdateCart();
                } else {
                  clearInterval(_this2.timelapseInterval);
                  _this2.timelapse = "00:00:00";
                  _this2.nbItems = 0;
                }
              }
            });
            document.addEventListener("visibilitychange", function () {
              var sessionId = getIdUserFromSession();
              if (!sessionId) setIdUserInSession();else if (sessionId !== getIdUserFromToken()) {
                alert("It seems that you have several tabs open with different users. The page will be reloaded.");
                setIdUserInSession();
                _this2.$router.push({
                  name: "userHome"
                }).catch(function () {});
                window.location.reload();
              }
            });
            setInterval(function () {
              refreshToken(_this2);
            }, 60 * 1000);
            _this2.cartDisabled = _this2.isCompletingOrder();
            order = orderHandler.getCurrentOrder();
            if (order && order.items.length > 0) {
              _this2.setTimelapse(order.date_insert);
              _this2.launchLockCancelationTimer(order);
            } else {
              _this2.timelapse = "00:00:00";
            }
            _this2.$EventBus.$on("BasketRemoved", function () {
              clearInterval(_this2.timelapseInterval);
              _this2.timelapse = "00:00:00";
              _this2.nbItems = 0;
            });
            _this2.$EventBus.$on("ItemRemoved", function (event) {
              _this2.nbItems = event.detail.items.reduce(function (acc, x) {
                return acc + x.quantity;
              }, 0);
            });
            _this2.$EventBus.$on("update-cart", _this2.eventUpdateCart);
            _this2.$EventBus.$on("add-item-to-cart", _this2.eventAddItemToCart);
            _this2.$EventBus.$on("order-made", _this2.eventOrderMade);
            _this2.$EventBus.$on("loading", _this2.toggleLoading);
            _this2.$EventBus.$on("loading-state", _this2.getLoadingState);
            _this2.$EventBus.$on("modal-warning", function (contents, buttonText, title) {
              _this2.modalWarningShown = true;
              _this2.modalWarning.contents = contents;
              _this2.modalWarning.buttonText = buttonText !== null && buttonText !== void 0 ? buttonText : "I understand";
              _this2.modalWarning.title = title !== null && title !== void 0 ? title : null;
              /* Using exemple in project :
              let errorContents = [
                { text: "An order seems to be in adjusting process in an other tab." },
                { text: "Please send this adjustment before starting a new cart." }
              ]
              this.$EventBus.$emit("modal-warning", errorContents)
              */
            });
            _this2.$EventBus.$on("startAddingItemsToCart", function () {
              _this2.areAllItemsAddedToCart = true;
            });
            _this2.$EventBus.$on("noMoreItemsToAddToCart", function () {
              _this2.areAllItemsAddedToCart = false;
            });
            _this2.buyer = hasRole(process.env.VUE_APP_ROLES_BUYER) || hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            _this = _this2;
            if (orderHandler.getCurrentOrder() == null && hasRole(process.env.VUE_APP_ROLES_BUYER)) {
              request("/v1/basket", "get", null, true, "api").then(function (response) {
                if (response.data) {
                  orderHandler.setCurrentOrder(response.data);
                  _this.launchLockCancelationTimer(response.data);
                }
              });
            }
            // we display the number of items in the cart
            _this2.eventUpdateCart();

            // we add an event listener in case we switch from portrait to landscape for example
            mql.addEventListener("change", _this2.isPortraitMobile);
            _this2.isPortraitMobile();
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.lockerTimelapseIntervale);
  },
  methods: {
    launchLockCancelationTimer: function launchLockCancelationTimer(order) {
      this.lockCancellationTimer(order);
      var _this = this;
      this.lockerTimelapseIntervale = setInterval(function () {
        _this.lockCancellationTimer(order);
      }, 60 * 1000);
    },
    lockCancellationTimer: function lockCancellationTimer(order) {
      return request("/v1/orders/".concat(order.id_order, "/cancellation_timer/lock"), "put", null, true, "api");
    },
    isCompletingOrder: function isCompletingOrder() {
      return Object.values(orderPaths).some(function (x) {
        return x === window.location.pathname;
      });
    },
    eventUpdateCart: function eventUpdateCart() {
      var newNbItems = 0;
      var order = orderHandler.getCurrentOrder();
      if (order !== null && order !== void 0 && order.items && (order === null || order === void 0 ? void 0 : order.creatorUserId) == this.loggedUserData.idUser && order.status == orderStatus.find(function (x) {
        return x.id == "CREATED";
      }).status) {
        order.items.forEach(function (item) {
          newNbItems = newNbItems + item.quantity;
        });
        this.nbItems = newNbItems;
        this.clearTimelapse();
        this.setTimelapse(order.date_insert);
      } else {
        this.nbItems = newNbItems;
        this.clearTimelapse();
      }
    },
    setTimelapse: function setTimelapse(time) {
      var _this = this;
      this.isCountdownElapsed = orderHandler.isCountdownElapsed(time);
      if (this.isCountdownElapsed) {
        this.timelapse = "00:00:00";
        return;
      }
      this.timelapseInterval = setInterval(function () {
        var now = new Date().getTime();
        var timeleft = orderHandler.getCountdown(time) - now;
        if (timeleft <= 0) {
          _this.isCountdownElapsed = true;
          _this.clearTimelapse();
        }
        var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        var hours = Math.floor(timeleft % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)).toString().padStart(2, "0");
        var minutes = Math.floor(timeleft % (1000 * 60 * 60) / (1000 * 60)).toString().padStart(2, "0");
        var seconds = Math.floor(timeleft % (1000 * 60) / 1000).toString().padStart(2, "0");
        _this.timelapse = "".concat(days ? ":" : "").concat(hours, ":").concat(minutes, ":").concat(seconds);
      });
    },
    clearTimelapse: function clearTimelapse() {
      clearInterval(this.timelapseInterval);
      this.timelapse = "00:00:00";
    },
    eventAddItemToCart: function eventAddItemToCart() {
      var order = orderHandler.getCurrentOrder();
      if (order) {
        this.clearTimelapse();
        this.launchLockCancelationTimer(order);
        this.setTimelapse(order.date_insert);
      }
      this.eventUpdateCart();
      if (!this.cart) this.showCart();
    },
    eventOrderMade: function eventOrderMade() {
      this.nbItems = 0;
    },
    disconnectUser: function disconnectUser() {
      clearInterval(this.timelapseInterval);
      disconnect(this);
    },
    showCart: function showCart(e) {
      this.cart = !this.cart && true;
      e === null || e === void 0 || e.stopPropagation();
    },
    shutCart: function shutCart(e) {
      if (!this.hoverCart || e.force) this.cart = this.cart && false;
    },
    menuAction: function menuAction(route, query) {
      return {
        name: route,
        query: {
          tab: query
        }
      };
    },
    isPortraitMobile: function isPortraitMobile() {
      var mql = window.matchMedia("(max-width: 500px)");
      this.portraitMobile = mql.matches;
    },
    toggleLoading: function toggleLoading(visible) {
      this.loading.isLoading = visible;
    },
    isUserBuyerGroup: isUserBuyerGroup
  },
  components: {
    "menu-component": menuComponent,
    cart: cart,
    Loading: Loading,
    "footer-component": footerComponent,
    ScheduledMaintenanceAlert: ScheduledMaintenanceAlert
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (isMobile() || isBreakPointMenuMobile()) {
      if ((to === null || to === void 0 ? void 0 : to.name) === "finalizeCart") {
        next();
      } else {
        if (this.cart) {
          this.shutCart({
            force: true
          });
          next(false);
        } else {
          next();
        }
      }
    } else {
      if (this.cart) this.shutCart({
        force: true
      });
      next();
    }
  }
};